import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-form-turn-schedule',
  templateUrl: './turns-form-turn-schedule.component.html',
  styleUrls: ['./turns-form-turn-schedule.component.scss']
})
export class TurnsFormTurnScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
